import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({acceso, redirectPath='/Page403'}) => {
    if(!acceso){
        return <Navigate to={redirectPath} replace />
    }
    return <Outlet />;
}
 
export default ProtectedRoute;